module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_parkin_spot.5d187520.svg";